import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateVehicleGroupDto } from '../../dtos/create-vehicle-group.dto';
import { UpdateVehicleGroupDto } from '../../dtos/update-vehicle-group.dto';
import { createVehicleGroupSchema } from '../schemas/create-vehicle-group.schema';
import { updateVehicleGroupSchema } from '../schemas/update-vehicle-group.schema';

/**
 * Validates record data for creation or update.
 */
export const canCreateOrUpdate = (
  record: CreateVehicleGroupDto | UpdateVehicleGroupDto,
  abortEarly: boolean = false,
): ValidationFunctionResult => {
  if (!record) throw new Error('record is required.');

  let validationResult: ValidationResult | undefined;

  if ('id' in record && record.id) {
    validationResult = updateVehicleGroupSchema().validate(record, {
      abortEarly,
    });
  } else {
    validationResult = createVehicleGroupSchema().validate(record, {
      abortEarly,
    });
  }

  if (validationResult?.error) {
    return {
      isValid: false,
      errors: validationResult.error.details?.map((error) => error.message),
    };
  }

  return { isValid: true };
};
